import { createContext } from "react";
import { type UseQueryResult } from "@tanstack/react-query";
import { type CanvasData } from "@/services/apitypes";
import { type ApiError as CanvasApiError } from "@/services/api";

export interface CanvasContextType {
  canvasResult: UseQueryResult<CanvasData, Error | CanvasApiError>;
  isParticipation: boolean;
  participationToken: string | undefined;
  externalId: string | undefined;
}

export const CanvasContext = createContext<CanvasContextType | undefined>(undefined);
